function removeBumpRecommendations() {
  document.querySelectorAll('h3.card__heading').forEach(function(heading) {
    if (heading.textContent.trim().includes('Off)')) {
      var card = heading.closest('li.grid__item') || heading.closest('li');
      if (card) card.remove();
    }
  });
}

setTimeout(removeBumpRecommendations, 3000);

var observer = new MutationObserver(function() {
  removeBumpRecommendations();
});
observer.observe(document.body, { childList: true, subtree: true });